import { useEffect, useState } from "react";
import { Sparkles, MessageCircle } from "lucide-react";
import { useUI } from "@/context/UIContext";
import { whatsappLink } from "@/lib/api";
import ChatWidget from "./ChatWidget";

export default function FloatingDock() {
  const { demo, bookingOpen, chosenExample } = useUI();
  const [chat, setChat] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const targets = ["kontakt", "site-footer-anchor", "vorher-nachher"].map((id) => document.getElementById(id)).filter(Boolean);
    const vis = new Map();
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => vis.set(e.target, e.isIntersecting));
      setHidden([...vis.values()].some(Boolean));
    }, { threshold: 0.05 });
    targets.forEach((t) => io.observe(t));
    return () => io.disconnect();
  }, []);

  const off = hidden || chat || demo.open || bookingOpen;
  return (
    <>
      <div className={`fixed bottom-4 right-4 z-30 flex flex-col items-end gap-3 transition-[opacity,transform] duration-300 sm:bottom-6 sm:right-6 ${off ? "pointer-events-none translate-y-4 opacity-0" : "opacity-100"}`} aria-hidden={off} data-testid="floating-dock">
        <a href={whatsappLink(chosenExample)} target="_blank" rel="noopener noreferrer" tabIndex={off ? -1 : 0} aria-label="Per WhatsApp schreiben" data-testid="floating-whatsapp"
          className="grid h-12 w-12 place-items-center rounded-full border border-line bg-white text-ink shadow-lg transition-transform active:scale-95">
          <MessageCircle className="h-5 w-5" />
        </a>
        <button type="button" onClick={() => setChat(true)} tabIndex={off ? -1 : 0} data-testid="chat-open"
          aria-label="Webhaus KI-Assistent öffnen" className="flex h-12 w-12 items-center justify-center gap-2 rounded-full bg-ink text-[14px] font-semibold text-paper shadow-xl transition-transform active:scale-95 sm:w-auto sm:pl-4 sm:pr-5">
          <Sparkles className="h-4 w-4 text-gold" /> <span className="hidden sm:inline">KI-Assistent</span>
        </button>
      </div>
      <ChatWidget open={chat} setOpen={setChat} />
    </>
  );
}
